import ProgramHub from "@/components/ProgramHub";
import { PROGRAMS } from "@/lib/programs";

export default function ConfidenceArise() {
  return <ProgramHub program={PROGRAMS["confidence-arise"]} />;
}
